import apiCalendarPlan from '@/api/calendar-plan'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getCalendarPlanStart: '[calendar plan] Get calendar plan start',
  getCalendarPlanSuccess: '[calendar plan] Get calendar plan success',
  getCalendarPlanFailure: '[calendar plan] Get calendar plan failure',

  getCalendarPlanByStateStart:
    '[calendar plan] Get calendar plan by state start',
  getCalendarPlanByStateSuccess:
    '[calendar plan] Get calendar plan by state success',
  getCalendarPlanByStateFailure:
    '[calendar plan] Get calendar plan by state failure',
}

export const actionTypes = {
  getCalendarPlan: '[calendar plan] Get calendar plan',
  getCalendarByStatePlan: '[calendar plan] Get calendar by state plan',
}

const mutations = {
  [mutationTypes.getCalendarPlanStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getCalendarPlanSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCalendarPlanFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getCalendarPlanByStateStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getCalendarPlanByStateSuccess](state, payload) {
    state.data = payload.data
    state.total = payload.total
    state.isLoading = false
  },

  [mutationTypes.getCalendarPlanByStateFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getCalendarPlan](context) {
    context.commit(mutationTypes.getCalendarPlanStart)
    return new Promise((resolve) => {
      apiCalendarPlan
        .getCalendarPlans()
        .then((response) => {
          context.commit(mutationTypes.getCalendarPlanSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getCalendarPlanFailure)
        })
    })
  },

  [actionTypes.getCalendarByStatePlan](context, {params}) {
    context.commit(mutationTypes.getCalendarPlanByStateStart)
    return new Promise((resolve) => {
      apiCalendarPlan
        .getCalendarPlansByParams(params)
        .then((response) => {
          context.commit(mutationTypes.getCalendarPlanByStateSuccess, response)
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getCalendarPlanByStateFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
